import React, { useState } from "react";
import authLogo from "../../../assets/auth_logo.png";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { Spinner } from "react-bootstrap";
import * as Yup from "yup";
import {
  usePostForgotPasswordMutation,
  usePostLoginMutation,
} from "../../../rtk-query/slices/auth/authSlice";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
function ForgotPasswordCard() {
  const navigate = useNavigate();
  const [postForgotPassword, { isLoading }] = usePostForgotPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values, { resetForm, setFieldError }) => {
      try {
        // navigate("/verify-token");
        const data = {
          email: values.email,
        };
        const response = await postForgotPassword(data);
        if (response?.data?.status) {
          toast.success(response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
          localStorage.setItem("DODLoginToken", response?.data?.token);
          resetForm(); // Clear the form
          localStorage.setItem("DODUserEmailToVerify", values.email);
          localStorage.setItem("DODUserEmailToVerifyNext", "reset-password");
          navigate("/verify-token");
          // Redirect to the onboarding screen
        }
        if (response?.error) {
          const errors = response?.error?.data?.errors;
          if (errors) {
            for (const field in errors) {
              if (errors.hasOwnProperty(field)) {
                const combinedErrors = errors[field].join(" ");
                setFieldError(field, combinedErrors);
              }
            }
            toast.error(response?.error?.data.message, {
              position: "top-center",
              autoClose: 3000,
            });
          } else {
            toast.error(response?.error?.data.message, {
              position: "top-center",
              autoClose: 3000,
            });
          }
        }
      } catch (error) {
        toast.error("An unexpected error occurred. Please try again.");
      }
    },
  });
  return (
    <div className="auth-card">
      <div className="auth-card-header d-flex align-items-center justify-content-center">
        <img src={authLogo} alt="logo" width={181} height={61} />
      </div>
      <div className="auth-card-body">
        <h1 className="auth-card-heading mb-2">Forgot your password</h1>
        <p className="auth-card-description">
          Provide your registered email to recover password 
        </p>
        <form onSubmit={formik.handleSubmit} className="auth-card-form mt-3">
          {/* email input field */}
          <div className="auth-card-form-group d-flex flex-column align-items-start gap-1">
            <label className="input-label" htmlFor="email">
              Email
            </label>
            <input
              className={`input-field ${
                formik.touched.email && formik.errors.email ? "is-invalid" : ""
              }`}
              type="email"
              disabled={isLoading}
              id="email"
              // placeholder="Email"
              {...formik.getFieldProps("email")}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="invalid-feedback">{formik.errors.email}</div>
            ) : null}
          </div>

          {/* login button */}
          <button
            type="submit"
            disabled={isLoading}
            className="w-100 auth-login-btn mt-4"
          >
            Click here to reset pasword {isLoading && <Spinner size="sm" />}
          </button>
          {/* terms and conditions */}
          <p className="auth-card-terms mt-4">
            By proceeding, you agree to the <span>Privacy Policy</span> and{" "}
            <span>Terms & Conditions</span>
          </p>
        </form>
      </div>
      <div className="auth-card-footer pt-3 pb-3">
        <p>
          Do not have an account? <Link to="/signup">Create Now</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPasswordCard;
